module.exports = __webpack_public_path__ + "img/rules.c1f7f0ed.png";